import React, { Component } from 'react'
import cx from 'classnames'
import styled from 'styled-components'
import { pick, result, values, keys } from 'libraries/lodash'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { updatePrecedentPositions } from 'services/PrecedentsService'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import notificationToast from 'helpers/notificationToast'
import ErrorIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { toast } from 'react-toastify'
import ItemContainer from 'redux/containers/pages/precedentscontent/ItemContainer'

const ItemList = styled.ul`
  /*background-color: ${props => (props.isDraggingOver ? 'white' : '#73797A')};*/
`
class Heading extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const filesInSection = result(nextProps.parents, nextProps.id, [])
    const pickedFiles = pick(nextProps.files, filesInSection)
    const items = [...values(pickedFiles)].sort((a, b) => a.position - b.position)

    if (pickedFiles !== prevState.files) {
      return {
        files: pickedFiles,
        dnd: {
          items,
          columns: {
            'column-1': {
              id: 'column-1',
              title: nextProps.title,
              itemIds: items.map(item => item.id)
            }
          },
          columnOrder: ['column-1']
        }
      }
    }
    return null
  }

  get length () {
    return keys(this.state.files).filter(k => this.state.files[k]).length
  }

  handleOnDragEnd = result => {
    const { destination, source, draggableId } = result
    const { aol } = this.props

    if (!destination) {
      return
    }

    if (/* user dropped item in same position */
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return
    }

    const column = values(this.state.dnd.columns).find((column) => column.id === 'column-1')

    /* clone the array */
    const newItemIds = Array.from(column.itemIds)

    /* remove one id from position source.index */
    newItemIds.splice(source.index, 1)

    /* insert draggable id at position destination.index */
    newItemIds.splice(destination.index, 0, draggableId)

    const items = [...this.state.dnd.items]

    const updatedItems = []

    newItemIds.forEach((id, index) => {
      const item = items.find(item => item.id === id)
      if (parseInt(item.position) !== index) {
        item.position = index
        updatedItems.push(item)
      }
    })

    const errorHandle = result => notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error:' + result, 'bg-indian-red white')

    updatePrecedentPositions(updatedItems, aol)
      .map(JSON.parse)
      .subscribe(
        res => {
          !res.success && errorHandle()
        },
        errorHandle
      )

    const newColumn = { ...column, itemIds: newItemIds }
    const newState = {
      ...this.state.dnd,
      items: [...items],
      columns: {
        ...this.state.dnd.columns,
        [newColumn.id]: newColumn
      }
    }
    this.setState({ dnd: newState })
  }

  render () {
    const { id, expanded, title, toggleExpandedSection, view, sectionId, flavour, sectionTitle } = this.props

    return (
      <li
        className='bb b--precedents-blue list-item-reset'
        id={getUrl(PRECEDENTS_CONTENT, { flavour, view, sectionId, expanded: id })}
        data-testid='document-accordion-section-header'
      >
        <SectionHeader
          toggle={toggleExpandedSection && (() => toggleExpandedSection(id))}
          title={title}
          expanded={expanded}
          count={this.length}
          sectionTitle={sectionTitle}
        />
        <DragList length={this.length} {...this.props} {...this.state} onDragEnd={this.handleOnDragEnd} {...this.context} />
      </li>
    )
  }
}

const SectionHeader = ({ count, title, toggle, expanded, sectionTitle }) => toggle
  ? (
    <div className={cx('hover-bg-precedents-blue-20 bg-precedents-blue-10', { 'bg-precedents-blue-exp': expanded })}>
      <a
        onClick={toggle}
        className='pointer'
        data-event-category='Precedents'
        data-event-action={!expanded ? 'Collapse' : 'Expand'} // looks wrong but the timing on when this gets read is a bit funky
        data-event-label={`${sectionTitle}: ${title}`}
      >
        <div className={cx('flex justify-between pv6', { white: expanded })}>
          <div className={cx('b black f5 ml6', { white: expanded })}>
            {title}
          </div>
          <div className='mr6 flex'>
            <span className='mr6 no-select'> {count} </span>
            {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </div>
        </div>
      </a>
    </div>
    )
  : (
    <div className='bg-precedents-blue-exp white pv6 b pl6'>
      {title}
    </div>
    )

const DragList = ({ length, expanded, toggleExpandedSection, dnd, onDragEnd: handleOnDragEnd, ...props }) => {
  if (!expanded && toggleExpandedSection) {
    return null
  }
  if (length === 0) {
    return <EmptyList />
  }

  const column = dnd.columns['column-1']
  const items = column.itemIds.map(itemId => dnd.items.find(item => item.id === itemId))

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId={column.id}>
        {(droppableProvided, _) => (
          <ItemList
            className='list-reset pa0 bg-grey'
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
          >
            {items.map((file, index) => (
              <DraggableItem
                key={file.id}
                {...{ file, index }}
                isLast={index === items.length - 1}
                {...props}
              />
            ))}
            {droppableProvided.placeholder}
          </ItemList>
        )}
      </Droppable>
    </DragDropContext>
  )
}

const DraggableItem = ({
  file,
  index,
  isLast,
  dragChildren,
  selectedIds,
  sectionId,
  userPermissions,
  refreshPrecedents,
  view
}) => {
  const { id, name, title, description } = file

  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!dragChildren}>
      {(draggableProvided, draggableSnapshot) => (
        <ItemContainer
          index={index}
          isLast={isLast}
          innerRef={draggableProvided.innerRef}
          id={id}
          item={file}
          name={name}
          title={title || name}
          description={description}
          selected={selectedIds ? (selectedIds[id] || 0) : undefined}
          view={view}
          sectionId={sectionId}
          userPermissions={userPermissions}
          refreshPrecedents={refreshPrecedents}
          provided={draggableProvided}
          snapshot={draggableSnapshot}
        />
      )}
    </Draggable>
  )
}
const EmptyList = () => (
  <ul className='file-list list-reset pa0'>
    <li className='ma6 ml9'>
      <div className='info grey'>
        No files to show
      </div>
    </li>
  </ul>
)

export default Heading
